/* eslint-disable no-restricted-imports */
import { selectWalletInfo, selectWalletInfoLoading } from '../../../data-layer/cpa/selectors';
import { CpaStatus } from '../../../data-layer/cpa/types';
import { useSelector } from '../../../data-layer/useSelector';
import { useCurrentUser } from '../../../routing/users/useCurrentUser';
import { useAdvertisingProfilePromoEnabled } from '../../../utils/useAdvertisingPromoEnabled';
import { CpaRewardContentButton } from './parts/CpaRewardContentButton/CpaRewardContentButton';
import { CpaRewardContentText } from './parts/CpaRewardContentText/CpaRewardContentText';

export const CpaRewardContent = () => {
    const currentUser = useCurrentUser();
    const cpaStatus = currentUser?.cpaStatus;

    const walletInfo = useSelector(selectWalletInfo);
    const isWalletLoading = useSelector(selectWalletInfoLoading);

    const hasPromo = useAdvertisingProfilePromoEnabled();

    if (cpaStatus === CpaStatus.TRIAL && walletInfo?.contractAvailable) {
        return (
            <CpaRewardContentButton
                walletInfo={walletInfo}
                isWalletLoading={isWalletLoading}
                promo={hasPromo}
            />
        );
    }

    return (
        <CpaRewardContentText
            walletInfo={walletInfo}
            isWalletLoading={isWalletLoading}
            cpaStatus={cpaStatus}
        />
    );
};
